import { Actions, type LoadingAction } from './index';

export const queryFailure = (queryName: string): LoadingAction => ({
  type: Actions.QUERY_FAILURE,
  payload: { queryName },
});
